// extracted by mini-css-extract-plugin
export var legendIndicator = "_cr-1";
export var legendRight = "_cr-0";